<div class="font-semibold text-2xl mt-8 mb-1 text-black dark:text-white/[.87]">
  <ng-content select="[heading-title]"></ng-content>
</div>
<div class="text-sm text-gray-500">
  <ng-content select="[heading-detail]"></ng-content>
</div>
